export function redacted() {
	const paragraphs = document.querySelectorAll('p.is-style-redacted');

	paragraphs.forEach((paragraph) => {
		const words = paragraph.textContent.split(' ');
		const redactableIndices = words
			.map((word, index) => word.length >= 4 ? index : null)
			.filter((index) => index !== null);

		// Determine the number of words to redact based on total word count
		const totalWords = words.length;
		const redactPercentage = totalWords < 20 ? 0.4 : 0.25;
		const numWordsToRedact = Math.floor(redactableIndices.length * redactPercentage);

		const randomIndices = [];
		while (randomIndices.length < numWordsToRedact) {
			const randomIndex = redactableIndices[ Math.floor(Math.random() * redactableIndices.length) ];
			if (!randomIndices.includes(randomIndex)) {
				randomIndices.push(randomIndex);
			}
		}

		const newHTML = words.map((word, index) => {
			if (randomIndices.includes(index)) {
				return `<span class="hidden-word">${ word }</span>`;
			}
			return word;
		}).join(' ');

		paragraph.innerHTML = newHTML;

		let timer;
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					timer = setTimeout(() => {
						paragraph.querySelectorAll('.hidden-word').forEach((element) => element.classList.add('revealed'));
					}, 10000);
				} else {
					clearTimeout(timer);
				}
			});
		});

		observer.observe(paragraph);
	});
}
